import InvoiceProgressTooltip from '@/components/DesignLibrary/InvoiceProgressTooltip';
import { Invoice } from '@/typings/api-models';
import { DEFAULT_CURRENCY } from '@/typings/common';
import React from 'react';
import classNames from 'classnames';

import s from './Workflow.module.scss';

type Props = {
    invoice: Pick<Invoice, 'amountPaid' | 'amountTotal' | 'amountPending' | 'amountDue'>;
    workflowName?: string;
    showBorder?: boolean;
};
const InvoiceProgress = (props: Props): JSX.Element => {
  const {
    invoice,
    workflowName = '',
  } = props;

  return (
    <div className={s.invoiceProgress}>
      {
        workflowName && (
          <span className={classNames(s.textGray, invoice.amountTotal !== 0 && s.separator)}>{workflowName}</span>
        )
      }
      {invoice.amountTotal !== 0 && <InvoiceProgressTooltip
        invoice={{
          ...invoice,
          currency: DEFAULT_CURRENCY,
        }}
        className={s.textBlack}
        hideIcon={true}
        hideProgress={true}
        title='Balance: '
        hideSuffix={true}
      />}
    </div>
  );
};

export default InvoiceProgress;
